import {
  currentFundingReasonFormNameRoutine,
  fundingAmountRoutine,
  CURRENT_FORM_NAME_CLEANUP,
  currentFundingReasonFormVersionRoutine
} from '@/store/modules/currentFormDetails/routines'
import { logoutRoutine } from '@/store/modules/auth/routines'
import { state as initialState } from './index'

export default {
  [currentFundingReasonFormNameRoutine.TRIGGER](context, payload) {
    context.commit(currentFundingReasonFormNameRoutine.TRIGGER, payload)
  },

  [currentFundingReasonFormVersionRoutine.TRIGGER](context, payload) {
    context.commit(currentFundingReasonFormVersionRoutine.TRIGGER, payload)
  },

  [fundingAmountRoutine.TRIGGER](context, payload) {
    context.commit(fundingAmountRoutine.TRIGGER, payload)
  },

  [logoutRoutine.SUCCESS](context) {
    context.commit(CURRENT_FORM_NAME_CLEANUP, initialState)
  }
}
